import { AutogenLayoutCommitmentAutoRating } from "./autogen/AutogenLayoutCommitmentAutoRating";

export class CommitmentAutoRating extends AutogenLayoutCommitmentAutoRating {
    onLoad(): void | Promise<void> {
        this.labelAwardVolume.text = "--";
        this.labelFrequency.text = "--";
        this.labelRemainingNeeded.text = "--";

        this.labelOfferedToday.text = "--";
        this.labelOfferedMonth.text = "--";
        this.labelOfferedWeek.text = "--";
        this.labelOfferedQuarter.text = "--";
        this.labelOfferedYear.text = "--";

        this.labelAcceptedToday.text = "--";
        this.labelAcceptedMonth.text = "--";
        this.labelAcceptedWeek.text = "--";
        this.labelAcceptedQuarter.text = "--";
        this.labelAcceptedYear.text = "--";

        this.labelRejectedToday.text = "--";
        this.labelRejectedMonth.text = "--";
        this.labelRejectedWeek.text = "--";
        this.labelRejectedQuarter.text = "--";
        this.labelRejectedYear.text = "--";


        this.labelRate.text = "--";
        this.labelRateNumber.text = "--";
        this.labelCommitmentId.text = "--";
        this.labelRateDescription.text = "--";
        this.labelDescr.text = "--";
    }
}